<template>
  <div>
    <div class="dv" v-if="Info !== null && Info">
      <div class="conte">
        <div style="display: flex">
          <img :src="Info.avatar" alt="" />
          <div style="margin-left: 8px">
            <div style="margin-top:10px">{{ Info.name || Info.clientName }}</div>
          </div>
        </div>
        <!-- <div class="copy">基本信息</div> -->
      </div>
      <div class="grin">
        <span>性别</span><span class="slon">{{ Info.gender === 1 ? "男" : (Info.gender === 2 ? "女" : '') }}</span>
      </div>
      <!-- <div class="grin">
        <span style="width: 40%">设置备注和描述</span><span></span>
      </div> -->
      <div class="grin">
        <span>标签</span>
        <span class="slon slon-label" v-for="(item,index) in Info.tagList" :key="index">{{item}}</span>
      </div>
      <div class="grin" v-if="Info.addTime">
        <span>添加时间</span><span class="slon">{{ Info.addTime }}</span>
      </div>
      <!-- <div class="grin"><span>类型</span><span></span></div> -->
      <div class="grin" v-if="Info.phone"><span>手机号</span><span class="slon">{{Info.phone}}</span></div>
      <div class="grin" v-if="Info.groupChatList.length > 0"><span>所在群聊</span><span class="slon"
          v-for="(item,index) in Info.groupChatList" :key="index">{{item}},</span></div>
    </div>
    <van-empty description="暂无信息" v-else />
    <!-- <div class="border">
      <div :class="border === 1 ? 'con_color' : 'con'" @click="border = 1">
        行为记录
      </div>
      <div :class="border === 2 ? 'con_color' : 'con'" @click="border = 2">
        跟进记录
      </div>
    </div> -->
    <van-list
      style="height: 200px"
      v-model="loading"
      :finished="finished"
      finished-text="我是有底线的~"
      @load="onLoad"
      :immediate-check="false">
        <van-steps direction="vertical" active-color="#333" v-for="(item, index) in readRecordList" :key="index">
          <van-step>
              <div>
                <span class="trends-title" v-if="item.contentType === 0">阅读文章</span>
                <span class="trends-title" v-if="item.contentType === 2">查看表单</span>
                <span class="trends-title" v-if="item.contentType === 3">查看文件</span>
                <span class="trends-title" v-if="item.contentType === 4">查看链接</span>
                <span class="trends-title" v-if="item.contentType === 7">扫码</span>
                <span class="trends-title" v-if="item.contentType === 8">查看企业名片</span>
                <span class="trends-title" v-if="item.contentType === 10">查看个人名片</span>
                <span class="trends-title" v-if="item.contentType === 16">浏览视频</span>
                <span class="trends-title" v-if="item.contentType === 17">查看图集</span>
                <span style="float: right;">{{item.startTime}}</span>
                <p style="margin-top: 5px;">标题：{{item.contentTitle}}</p>
                <p class="time">时长：{{item.duration || 0}} 秒</p>
                <p class="sharePeople">分享人:{{item.shareUserName}}</p>
              </div>
          </van-step>
        </van-steps>
      </van-list>
  </div>
</template>

<script>
import { timeFormat } from "../../utils/index";
export default {
  props: {
    href: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      default: 'toolBar'
    },
    customerDetails: {
      type: Object
    },
    theContactId: {
      type: Number || String,
      default: null
    }
  },
  data () {
    return {
      Info: null,
      border: 1,
      userId: "",
      readRecordList: [],
      loading: false,
      finished: false,
      page: 1,
      pageCount: 10,
    };
  },
  created () {
    if (this.type === 'toolBar') {
      this.getJsSDK();
    } else {
      this.Info = this.customerDetails
      this.Info.tagList = this.Info.labelList.map((item) => item.labelName)
      this.Info.addTime = ''
      this.Info.groupChatList = []
      this.getDrendsData()
    }

    console.log(this.Info, 'Info')
  },
  methods: {
    getconfig () {
      wx.config({
        beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: this.config.corpid, // 必填，企业微信的corpID
        timestamp: this.config.timestamp, // 必填，生成签名的时间戳
        nonceStr: this.config.nonceStr, // 必填，生成签名的随机串
        signature: this.config.signature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
        jsApiList: ["agentConfig"], // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
      });
      let that = this;
      wx.ready(function() {
        wx.agentConfig({
          corpid: that.config.corpid, // 必填，企业微信的corpid，必须与当前登录的企业一致
          agentid: that.config.agentId, // 必填，企业微信的应用id （e.g. 1000247）
          timestamp: that.config.timestamp, // 必填，生成签名的时间戳
          nonceStr: that.config.nonceStr, // 必填，生成签名的随机串
          signature: that.config.agentSignature, // 必填，签名，见附录-JS-SDK使用权限签名算法
          jsApiList: ["selectExternalContact", "getCurExternalContact"], //必填
          success: function(res) {
            // 回调
            wx.invoke("getCurExternalContact", {}, function(res) {
              if (res.err_msg == "getCurExternalContact:ok") {
                that.userId = res.userId; //返回当前外部联系人userId
                that.$http
                  .get("/scrm/v1/wxcp-chat-tool/p/findClientInfo", {
                    params: {
                      corpId: that.href.corpId,
                      externalUserId: that.userId,
                    },
                  })
                  .then((res) => {
                    if (res.code === 1) {
                      if (res.data && res.data !== null) {
                        that.Info = res.data
                        that.Info.addTime = timeFormat(that.Info.addTime, 'yyyy/MM/dd hh:mm:ss')
                        that.Info.groupChatList = res.data.groupChatList || []
                      } else if (res.data === null || res.data.length < 1) {
                        that.Info = null
                      }
                    } else {
                      that.Info = null
                    }
                  });
                // 查询企业微信客户行为轨迹
                that.getRecordList()
              } else {
                //错误处理
              }
            });
          },
          fail: function(res) {
            console.log(res, "fail");
            if (res.errMsg.indexOf("function not exist") > -1) {
              alert("版本过低请升级");
            }
          },
        });
      });
    },
    //获取jsSDK信息
    getJsSDK () {
      this.$http
        .get("/scrm/v1/wxcp-corp/p/getJsSDK", {
          params: {
            corpId: this.href.corpId,
            url: window.location.href.split("#")[0], //'http://scrm-wxwork-ui.ngrok.gznino.com:8080/'
          },
        })
        .then((res) => {
          if (res.code === 1) {
            this.config = res.data;
            this.getconfig();
          }
        });
    },
    onLoad() {
        this.loading = true
        this.page++
        if (this.type === 'toolBar') {
          this.getRecordList()
        } else {
          this.getDrendsData()
        }
    },
    getRecordList() {
      this.$http.get("/scrm/v1/wxcp-chat-tool/p/findReadRecById", {
        params: {
          corpId: this.href.corpId,
          externalUserId: this.userId,
          page: this.page,
          pageCount: this.pageCount
        },
      })
      .then((res) => {
        const { code, data } = res
        if (code === 1) {
          setTimeout(() => {
            if (data && data.records.length > 0) {
              this.loading = false
              this.readRecordList = this.readRecordList.concat(data.records)
            }
            if (this.readRecordList.length >= data.total) {
              this.finished = true;
            } else {
              this.finished = false;
            }
          }, 1000)
        }
      })
    },

    // 获取客户动态（企微宝行为轨迹）
    getDrendsData() {
      this.$http
        .get("/scrm/v1/qw-client/m/findClientById", {
          params: {
            id: this.theContactId,
            page: this.page,
            pageCount: this.pageCount
          },
        })
        .then((res) => {
          const { code, data } = res
          if (code === 1) {
            setTimeout(() => {
              if (data && data.records.length > 0) {
                this.loading = false
                this.readRecordList = this.readRecordList.concat(data.records)
              }
              if (this.readRecordList.length >= data.total) {
                this.finished = true;
              } else {
                this.finished = false;
              }
            }, 1000)
          }
        })
    },
  },
};
</script>
 
<style lang = "less" scoped>
.dv {
  padding: 0 10px;
  font-size: 14px;
  /* border-bottom: 10px solid #efefef; */
  .conte {
    padding: 18px 0;
    border-bottom: 1px solid #f3f3f3;
    display: flex;
    justify-content: space-between;
    img {
      display: block;
      width: 32px;
      height: 32px;
    }
  }
  .copy {
    height: 29px;
    text-align: center;
    line-height: 29px;
    font-size: 16px;
  }
  .grin {
    color: #999;
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 15px 10px;
    /* height: 40px; */
    /* line-height: 40px; */
    span {
      display: inline-block;
      &:nth-child(1) {
        width: 22%;
      }
    }
    .slon {
      color: #333;
      /* margin-right: 5px; */
    }
  }
}
.slon-label {
  padding: 6px 15px;
  margin: 0 10px 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1354d3 !important;
  font-size: 12px;
  background: #edf8ff;
  border: 1px solid #b1c9fa;
  border-radius: 4px;
}
.border {
  display: flex;
  padding: 10px;
  .con {
    font-size: 14px;
    width: 35%;
    height: 30px;
    background-color: #f0f0f2;
    text-align: center;
    line-height: 30px;
    border-radius: 18px;
    margin-right: 20px;
  }
  .con_color {
    font-size: 14px;
    width: 35%;
    height: 30px;
    text-align: center;
    line-height: 30px;
    border-radius: 18px;
    margin-right: 20px;
    background-color: #e6e6ff;
    border: 1px solid #9494e8;
  }
}
.client-trends {
  font-size: 18px;
  font-weight: 500;
  margin: 10px 15px;
}
.trends-title {
  font-size: 18px;
  font-weight: 600;
}
</style>
